export default __webpack_public_path__ + "static/media/aging.58367ec8.jpg";